import { STORED_VALUE_BASE_URL } from './stored-value.constants';

export const routeCreator = {
  base: `${STORED_VALUE_BASE_URL}`,
  create: `${STORED_VALUE_BASE_URL}/create`,
  update: (storedValueProgramId: string) =>
    `${STORED_VALUE_BASE_URL}/update/${storedValueProgramId}`,
  updateWithTab: (storedValueProgramId: string, tab: string) =>
    `${STORED_VALUE_BASE_URL}/update/${storedValueProgramId}/${tab}`,
  updateByOffer: (offerId: string) => `${STORED_VALUE_BASE_URL}/update-by-offer/${offerId}`,
  details: `${STORED_VALUE_BASE_URL}/details`,
  list: `${STORED_VALUE_BASE_URL}/list`,
};
